import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from 'app/i18n';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: 'prompt-modal.component.html'
})
export class PromptModalComponent {
  @Output() response: EventEmitter<any> = new EventEmitter();
  @Input() title = '';
	@Input() message = '';
  @Input() subMessage = '';
  @Input() userInput = '';
  @Input() loading = false;

  constructor(
    private translate : TranslateService,
    private modalService : BsModalService,
    public bsModalRef: BsModalRef) 
  { }

  confirm() {
    this.response.emit({confirm: true, msg: this.userInput});
  }

  closeModal() {
    this.response.emit({confirm: false, msg: this.userInput});
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/directives/prompt-modal/prompt-modal.component.ts